// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pointer[data-v-98e56a6c] {\r\n  cursor: pointer;\n}\n[data-v-98e56a6c] .options-vertical {\r\n  background-color: #f7f7f7 !important;\r\n  padding: 0px !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
